// React
import { useEffect, useState } from "react"

// Components
import { Button, HeaderMenu, Loading, Select } from "components"

// Utils
import { useLocation } from "utils"
import LiquidityRatioTable from "./components/LiquidityTableSection"
import { liquidityApis, useLiquidityRatio } from "./utils/hooks/useLiquidityRatio"
import { LiquidityKey } from "./types/liquidityTableType"
import { useLiquidityRatioYearly, yearlyApis } from "./utils/hooks/useLiquidityYearRatio"
import LiquidityYearlyTable from "./components/liquidityYearlyTable"

export default function Key(): JSX.Element {

  const location = useLocation()

  const [year, setYear] = useState<string | undefined>()
  const [locationId, setLocationId] = useState<number | "">("")
  const [tableData, setTableData] = useState<LiquidityKey[]>([])
  const [isUpdated, setIsUpdated] = useState(false)
  

  // const isFilterReady = Boolean(year)

  const currentYear = new Date().getFullYear()

  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const y = currentYear - i
    return {
      label: String(y),
      value: String(y)  
    }
  })

  const {
    liquidityData,
    loading,
    refetchLiquidity
  } = useLiquidityRatio(Number(year), String(locationId))

  const {
    yearlyData,
    loading: yearlyLoading,
    refetchYearly
  } = useLiquidityRatioYearly(Number(year), String(locationId))

  useEffect(() => {
    if (liquidityData.length > 0) {
      setTableData(liquidityData)
    } else {
      setTableData(emptyLiquidityData)
    }
    // eslint-disable-next-line
  }, [liquidityData])

  const liquidityKeys = liquidityApis 

  const liquidityYearlyKeys = yearlyApis
  
  function createEmptyLiquidityData(keys: {
    key_description: string
    code_budget: string
    category: string
  }[]) {
    const months = [
      "january","february","march","april","may","june",
      "july","august","september","october","november","december"
    ]
  
    return keys.map((key) => ({
      ...key,
      budget: "",
      average: "",
      ...Object.fromEntries(months.map((m) => [m, null]))
    }))
  }

  const createEmptyYearlyData = (keys: typeof liquidityYearlyKeys) => {
    const currentYear = new Date().getFullYear()
  
    const years = Array.from({ length: 6 }, (_, i) => currentYear - i)
  
    return keys.map((key) => ({
      ...key,
      data: years.map((year) => ({
        year,
        budget_id: null,
        budget: "",
        actual: ""
      }))
    }))
  }
  
  const emptyLiquidityData = createEmptyLiquidityData(liquidityKeys) as LiquidityKey[]
  const emptyYearlyData = createEmptyYearlyData(liquidityYearlyKeys)

  return (
    <section className="flex flex-col gap-3">

      <HeaderMenu title="8 KEY ANALYTIC" />

      {/* FILTER */}
      <section className="flex flex-wrap justify-end gap-3">

        <div className="max-w-[200px] w-full">
          <Select
            placeholder="Select Year"
            options={yearOptions}
            value={yearOptions.find(opt => opt.value === year)}
            onChange={(val) =>
              setYear(val?.value ? String(val.value) : undefined)
            }
          />
        </div>

        <div className="max-w-[200px] w-full">
          <Select
            isLoading={location.isLoading}
            options={[
              { label: "ALL", value: "" },
              ...(location.data ?? [])
            ]}
            value={
              [
                { label: "ALL", value: "" },
                ...(location.data ?? [])
              ].find((opt) => opt.value === locationId)
            }
            onChange={(val) => {
              if (!val?.value) {
                setLocationId("")
                return
              }

              setLocationId(Number(val.value))
            }}
          />
        </div>
        
        <Button
          color="primary"
          disabled={!year}
          onClick={() => {
            refetchLiquidity()
            refetchYearly()
            setIsUpdated(true)
          }}
        >
          UPDATE
        </Button>

      </section>

      {/* TABLE */}
      {loading ? (
        <Loading loading />
      ) : (
        <LiquidityRatioTable
          list={tableData}
          setList={setTableData}
          year={Number(year)}
          locationId={locationId === "" ? null : locationId}
          isFilterReady={isUpdated}
        />
      )}

      {/* TABLE */}
      {yearlyLoading ? (
        <Loading loading />
      ) : (
        <section className="mt-6">
          <LiquidityYearlyTable
            list={
              yearlyData.length > 0
                ? yearlyData
                : emptyYearlyData
            }
            isFilterReady={isUpdated}
          />
        </section>
      )}

    </section>
  )
}